import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ManagedJobProfileTemplateResponse } from '../../../../../data-contract/job-profile-template';
import { useApplicationFetchers } from '../../../../../fetchers/use-application-fetchers';
import { companySettingsKeys } from '../../../../api/query-keys';

function getLatestManagedTemplate(
    templates: readonly ManagedJobProfileTemplateResponse[],
): ManagedJobProfileTemplateResponse | null {
    if (templates.length === 0) {
        return null;
    }

    const sorted = [...templates].sort((a, b) => new Date(b.activatedAt).getTime() - new Date(a.activatedAt).getTime());
    return sorted[0] ?? null;
}

export const useManagedTemplate = (
    enabled: boolean = true,
): UseQueryResult<ManagedJobProfileTemplateResponse | null, Error> => {
    const { fetchManagedJobProfileTemplates } = useApplicationFetchers();

    return useQuery({
        enabled,
        queryFn: async () => {
            const result = await fetchManagedJobProfileTemplates();

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: companySettingsKeys.managedJobProfileTemplates(),
        staleTime: 60_000,
        select: getLatestManagedTemplate,
        throwOnError: true,
    });
};
